module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/194.71dc30eb.png";